<template>
  <el-dialog title="用户详情" :visible.sync="showDialog" append-to-body width="800px">
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" :disabled="openType=='see'" label-width="140px" class="orgForm">
      <!-- <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="照片">
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :on-change="onChange"
              :auto-upload="true"
              :http-request="upLoadPhoto"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="ruleForm.photo" :src="ruleForm.photo" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          
        </el-col>
      </el-row> -->
      
      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input size="small" v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" prop="phone">
            <el-input size="small" v-model="ruleForm.phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="邮箱" prop="email">
            <el-input size="small" v-model="ruleForm.email"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号" prop="idCard">
            <el-input size="small" v-model="ruleForm.idCard"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
         <el-col :span="12">
          <el-form-item label="联系地址" prop="address">
            <el-input size="small" v-model="ruleForm.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="参加工作时间">
            <el-date-picker
              size="small"
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.workDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="学位">
            <el-input size="small" v-model="ruleForm.degree"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历">
            <el-input size="small" v-model="ruleForm.education"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="毕业时间">
            <el-date-picker
              size="small"
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.graduateAt"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生日">
            <el-date-picker
              size="small"
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.birth"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="毕业院校">
            <el-input size="small" v-model="ruleForm.graduateInstitutions"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="执业证书编码">
            <el-input size="small" v-model="ruleForm.certificateNo"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="涉外公证资格">
            <el-select size="small" v-model="ruleForm.isForeign" clearable placeholder="请选择">
              <el-option label="已取得" value="1"></el-option>
              <el-option label="未取得" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="涉外取得时间">
            <el-date-picker
              size="small"
              type="date"
              placeholder="涉外公证资格取得时间"
              v-model="ruleForm.isForeignDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="执业证书颁发时间">
            <el-date-picker
              size="small"
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.issueDate"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="专业">
            <el-input size="small" v-model="ruleForm.major"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="职务">
            <el-input size="small" v-model="ruleForm.associationPost"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名拼音">
            <el-input size="small" v-model="ruleForm.pinyin"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="政治面貌">
            <el-input size="small" v-model="ruleForm.politicsStatus"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="专业职称">
            <el-input size="small" v-model="ruleForm.professionalTitles"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="考核任职资格">
            <el-input size="small" v-model="ruleForm.qualification"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="资格证号">
            <el-input size="small" v-model="ruleForm.qualificationCode"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">
          <el-form-item label="性别">
            <el-select size="small" v-model="ruleForm.sex" clearable placeholder="请选择">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员编制">
            <el-input size="small" v-model="ruleForm.staff"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="12">

        </el-col>
        <el-col :span="12">
          <el-form-item label="民族">
            <el-input size="small" v-model="ruleForm.nation"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <!-- <el-button size="small" type="primary" @click="submitForm('ruleForm')">下一步</el-button> -->
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <!-- <el-button size="small" @click="resetForm('ruleForm')">重置</el-button> -->
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import NotaryForm from './notary-form';
import {mapGetters} from 'vuex';
export default {
  props: {
    currUserId: {
      required: true
    }
  },
  components: {
    NotaryForm
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!/^1[123456789]\d{9}$/.test(value)) {
        return callback(new Error('手机号格式不正确'));
      } else {
        return callback()
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)) {
        return callback(new Error('邮箱格式不正确'));
      } else {
        return callback()
      }
    };
    var checkCardNo = (rule, value, callback) => {
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        return callback(new Error('身份证号格式不正确'));
      } else {
        return callback()
      }
    };
    return {
      showDialog: false,
      ruleForm: {
        qmFile: '',
        address: "", // 地址
        associationPost: "", // 协会职务
        birth: "", // 生日
        certificateNo: "", // 执业证书编码
        degree: "", // 学位
        education: "", // 学历
        email: "", // 邮箱
        graduateAt: "", // 毕业时间
        graduateInstitutions: "", // 毕业院校
        idCard: "", // 身份证
        isForeign: "", // 是否取得涉外公证资格  0表示没有取得  1表示取得
        isForeignDate: "", // 涉外公证资格取得时间
        issueDate: "", // 执业证书颁发时间
        major: "", // 专业
        name: "", // 姓名
        nation: "", // 民族
        phone: "", // 手机号
        photo: "", // 照片
        pinyin: "", // 拼音
        politicsStatus: "", // 政治面貌
        professionalTitles: "", // 专业职称
        qualification: "", // 考核任职资格
        qualificationCode: "", // 资格证号
        sex: "", // 性别 0女 1男
        staff: "", // 人员编制
        workDate: "" // 参加工作时间
      },
      rules: {
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        associationPost: [{ required: true, message: "请输入职务", trigger: "blur" }],
        birth: [{ required: true, message: "请选择时间", trigger: "change" }],
        certificateNo: [{ required: true, message: "请输入执业证书编码", trigger: "blur" }],
        degree: [{ required: true, message: "请输入学位", trigger: "blur" }],
        education: [{ required: true, message: "请输入学历", trigger: "blur" }],
        graduateAt: [{ required: true, message: "请选择时间", trigger: "change" }],
        graduateInstitutions: [{ required: true, message: "请输入毕业院校", trigger: "blur" }],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { validator: checkCardNo, trigger: 'blur' }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: 'blur' }
        ],
        isForeign: [{ required: true, message: "请选择是否取得涉外公证资格", trigger: "change" }],
        isForeignDate: [{ required: true, message: "请选择涉外公证资格取得时间", trigger: "change" }],
        issueDate: [{ required: true, message: "请选择执业证书颁发时间", trigger: "change" }],
        major: [{ required: true, message: "请输入专业", trigger: "blur" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        nation: [{ required: true, message: "请输入名族", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: 'blur' }
        ],
        photo: [{ required: true, message: "请上传照片", trigger: "blur" }],
        qmFile: [{ required: true, message: "请上传签名图片", trigger: "blur" }],
        pinyin: [{ required: true, message: "请输入姓名拼音", trigger: "blur" }],
        politicsStatus: [{ required: true, message: "请输入政治面貌", trigger: "blur" }],
        professionalTitles: [{ required: true, message: "请输入专业职称", trigger: "blur" }],
        qualification: [{ required: true, message: "请输入考核任职资格", trigger: "blur" }],
        qualificationCode: [{ required: true, message: "请输入资格证号", trigger: "blur" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        staff: [{ required: true, message: "请输入人员编制", trigger: "blur" }],
        workDate: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
      openType: 'see',
      applySignFormData: new FormData(),
    };
  },
  computed: {
    ...mapGetters({
      depts: "enum/depts",
      account: "user/account"
    })
  },
  watch: {
    currUserId: {
      immediate: false,
      handler(newId) {
        if (newId) {
          this.$api.getNotaryDetails(newId).then(res => {
            if (res.data.code === '200') {
              this.ruleForm = res.data.data.data;
            }
            // console.log(res.data.data.data);
          });
        }
      }
    }
  },
  created() {
  },
  methods: {
    open(openType) {
      this.showDialog = true;
      this.openType = openType
    },
    close() {
      this.showDialog = false;
    },
     // 保存公证员信息
    saveNotary(params) {
      this.$api.saveNotary({
        ...this.ruleForm,
        ...params
      }).then(res => {
        if (res.data.code === '200') {
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.close();
          this.$emit('updateList');
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveNotary();
          // this.applySign();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 上传图片
    upLoadPhoto(data) {
      let param = new FormData();
      param.append("file", data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.photo = res.data.data.urf;
      });
    },
    
    // 申请签名
    applySign() {
      this.applySignFormData.append("loginMobile", this.ruleForm.phone);
      this.applySignFormData.append("idCardNo", this.ruleForm.idCard);
      this.applySignFormData.append("userName", this.ruleForm.name);
      this.applySignFormData.append("address", this.ruleForm.address);
      this.applySignFormData.append("sex", this.ruleForm.sex=='0'?'女':'男');
      this.applySignFormData.append("userId", this.currUserId);
      this.$api.applySign(this.applySignFormData).then(res => {
        if (res.data.code === '200') {
          let custNo = res.data.data.custNo
          // 保存
          this.saveNotary({
            custNo: custNo
          });
        }
      }).finally(() => {
        this.applySignFormData = new FormData();
      })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image";
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    // 改变文件
    onChange(file, fileList) {
      console.log(file, fileList);
    },
  }
}
</script>
<style lang="less" scoped>
.box {
  width: 800px;
  margin-top: 20px;
}
.avatar-uploader {
  height: 100px;
}
/deep/ .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.el-select {
  display: inline-block;
  position: relative;
  width: 100%;
}
</style>